import i18n from "@/i18n";
import { getDataLowLiquidityArbitrage } from "@services/alert/low-liquidity-arbitrage";
import dayjs from "dayjs";

const state = {
    autoRefreshTimeOffset: 1,
    loading: false,
    alertData: [],
    alertHeader: [
        { text: i18n.t("common.table.login"), value: "login" },
        {
            text: i18n.t("common.table.name"),
            value: "name",
            sortable: false,
        },
        { text: "Book", value: "books", align: "left" },
        {
            text: i18n.t("common.table.ccy"),
            value: "ccy",
        },
        {
            text: i18n.t("common.table.today_open_trades_profit"),
            value: "today_open_trades_profit",
        },
        {
            text: i18n.t("common.table.low_liquidity_profit"),
            value: "low_liquidity_profit",
        },
        {
            text: i18n.t("common.table.top_symbol"),
            value: "top_symbol",
        },
        {
            text: i18n.t("common.table.trigger_time"),
            value: "trigger_time",
        },
    ],
    alertDataAmount: 0,
    csvHeader: {
        "Server Name": "server_name",
        Login: "login",
        Name: "name",
        Book: "books",
        CCY: "ccy",
        "PNL USD(Today)": "today_open_trades_profit",
        "Low Liquidity PNL": "low_liquidity_profit",
        Symbol: "top_symbol",
        "Trigger Time": "trigger_time",
    },
    selectedDate: null,
};

const actions = {
    getDataLowLiquidityArbitrageAction({ commit }, data) {
        commit("UPDATE_LOADING", true);
        getDataLowLiquidityArbitrage(data).then((res) => {
            res.data.data.forEach((item) => {
                item["books"] = item["books"]?.replace(/[[\]]/g, "") || "N/A";
            });
            commit("UPDATE_ALERT_DATA", res.data.data);
            commit("UPDATE_AMOUNT", res.data.count);
            commit("UPDATE_LOADING", false);
        });
    },
};

const mutations = {
    UPDATE_MONITOR_DATA(state, data) {
        state.monitorData = data;
    },
    UPDATE_ALERT_DATA(state, data) {
        state.alertData = data;
    },
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_ALERT_HEADER(state, data) {
        state.alertHeader = data;
    },
    UPDATE_SELECTED_DATE(state, data) {
        state.selectedDate = dayjs(data).unix();
    },
    UPDATE_AMOUNT(state, data) {
        state.alertDataAmount = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
